module.exports = __webpack_public_path__ + "img/slideshow3.68856b5b.jpg";